import React from "react";

interface AddChoiceIconProps {
  size?: number | string;
  className?: string;
  onClick?: () => void;
}

const AddChoiceIcon: React.FC<AddChoiceIconProps> = ({
  size = 22,
  className,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M11 6V16"
      stroke="#5CB25C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 11H16"
      stroke="#5CB25C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default AddChoiceIcon;